// src/components/Pentests/tabs/Tools.js
import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { Bug, Crosshair, Network, ShieldAlert, Split } from 'lucide-react';

import ReconLauncher from './tools/ReconLauncher';
import PortScanLauncher from './tools/PortScanLauncher';
import VulnScanLauncher from './tools/VulnScanLauncher';
import ZapLauncher from './tools/ZapLauncher';
import ProbeLauncher from './tools/ProbeLauncher';

const SUB_TABS = [
  { to: 'recon', label: 'Recon', icon: Crosshair },
  { to: 'port-scan', label: 'Port Scan', icon: Network },
  { to: 'vuln-scan', label: 'Vulnerability Scan', icon: ShieldAlert },
  { to: 'zap', label: 'ZAP', icon: Bug },
  { to: 'probe', label: 'Probe', icon: Split },
];

export default function Tools({ pentest }) {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 px-1">
        {SUB_TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm border transition ${
                isActive
                  ? 'border-shinobi-green/60 bg-wasabi-100 text-wasabi-700'
                  : 'border-cyber-300/40 bg-cyber-50/40 text-slate-700 hover:border-cyber-300 hover:text-slate-900'
              }`
            }
          >
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}
      </div>

      <div className="rounded-2xl border border-cyber-300/40 bg-cyber-50/60 p-5">
        <Routes>
          <Route index element={<Navigate to="recon" replace />} />
          <Route path="recon" element={<ReconLauncher pentest={pentest} />} />
          <Route path="port-scan" element={<PortScanLauncher pentest={pentest} />} />
          <Route path="vuln-scan" element={<VulnScanLauncher pentest={pentest} />} />
          <Route path="zap" element={<ZapLauncher pentest={pentest} />} />
          <Route path="probe" element={<ProbeLauncher pentest={pentest} />} />
        </Routes>
      </div>
    </div>
  );
}
